import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { ApplicationCardAddress } from '@widgets/cabinet/applicationCard/ApplicationCardAddress';
import { ApplicationCardShortItem } from '@widgets/cabinet/applicationCard/ApplicationCardShortItem';
import { ApplicationCardWhoNeeds } from '@widgets/cabinet/applicationCard/ApplicationCardWhoNeeds';
import { Application } from '@widgets/cabinet/applicationCard/types';

import config from '@config';
import { Shop } from '@hooks/useIntegrationConfigs';
import { AccordionButton } from '@shared/buttons/accordion';
import { PrimaryDropdown } from '@shared/dropdowns/PrimaryDropdown';
import { HowToHelpType } from '@shared/enums';
import { ErrorList } from '@shared/ui/ErrorList';
import { MastercardPrePaymentBanner } from '@shared/ui/banner/MastercardPrePaymentBanner';
import { AmountButton } from '@shared/ui/buttons/AmountButton';
import { isDefaultView } from '@shared/utils/applications';
import { AccordionApplicationCardItemsTitle } from '@widgets/cabinet/applicationCard/AccordionApplicationCardItemsTitle';
import { ApplicationCardItemDetails } from '@widgets/cabinet/applicationCard/ApplicationCardItemDetails';
import { ApplicationOnlineAmountNote } from '../../ApplicationOnlineAmountNote';
import { ShopOfferAgreementCheckbox } from '../../form/shop-offer-agreement-checkbox';

// TODO: refactor

interface ApplicationConfirmModalBodyProps {
  application: Application;
  amounts: any[];
  amount: number | null;
  type: string | null;
  errors: string[];
  shop: Shop | null;
  types: { text: string; type: string }[];
  onIsApprovedChange: (approved: boolean) => void;
  onAmountChange: (amount: number) => void;
  onTypeChange: (type: string) => void;
}

const useComponentState = (props: ApplicationConfirmModalBodyProps) => {
  const {
    amount,
    amounts,

    type,
    types,
    onTypeChange,

    onIsApprovedChange,
    onAmountChange,
    application,
    errors,
    shop,
  } = props;
  const [isCollapsed, setIsCollapsed] = React.useState(false);

  const { t } = useTranslation();

  const typeOptions = React.useMemo(() => types.map(({ text, type }) => ({ value: type, label: t(text) })), [t, types]);

  return {
    application,
    shop,
    errors,

    amount,
    amounts,

    type,
    typeOptions,

    isCollapsed,
    setIsCollapsed,

    actions: {
      onAmountChange,
      onTypeChange,
      onIsApprovedChange,
    },
  };
};

export const ApplicationOnlineHelpModalBody: React.FC<ApplicationConfirmModalBodyProps> = (props) => {
  const { t } = useTranslation();

  const { application, shop, errors, amount, amounts, type, typeOptions, actions, isCollapsed, setIsCollapsed } =
    useComponentState(props);
  const { view, customer, items } = application;

  const ApplicationCardItem = isDefaultView(view) ? ApplicationCardShortItem : ApplicationCardItemDetails;

  return (
    <div>
      {typeOptions.length > 1 && (
        <PrimaryDropdown
          className="w-full mb-10"
          label="choose-way"
          value={type}
          options={typeOptions}
          onChange={actions.onTypeChange}
        />
      )}
      <div className="flex flex-wrap justify-center mb-8 gap-2">
        {amounts.map((item, idx) => (
          <AmountButton
            key={idx}
            count={item.count}
            amount={item.value}
            active={amount === item.value}
            onClick={actions.onAmountChange}
          />
        ))}
      </div>
      {/* {shop?.category === HowToHelpType.OnlineFood && config.payments.mastercardBonusEnabled && (
        <MastercardPrePaymentBanner className="mb-8" />
      )} */}
      {shop && <ApplicationOnlineAmountNote amount={amount || 0} category={shop.category} />}
      <AccordionButton
        defaultCollapsed={false}
        summary={<ApplicationCardAddress className="text-black" address={customer.address} />}
        size="big"
        children={
          <div className="flex flex-col gap-y-6">
            <ApplicationCardWhoNeeds customer={customer} items={items} view={view} className="text-xs" withoutClamp />

            <div>
              <AccordionApplicationCardItemsTitle view={view} isCollapsed={isCollapsed} onClick={setIsCollapsed} />
              {isCollapsed && items.map((item) => <ApplicationCardItem key={item.id} {...item} />)}
            </div>
          </div>
        }
      />
      {shop && (
        <ShopOfferAgreementCheckbox
          id={String(application.id)}
          className="mt-10"
          shop={shop}
          onIsApprovedChange={actions.onIsApprovedChange}
        />
      )}
      <ErrorList className="mt-5" errors={errors.map((error) => t(error))} />
    </div>
  );
};
